import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ApprovalDetailPage } from '@/features/ai/agents/agents-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Une validation d’agent : corps figé, approuver ou refuser (ré-authentification). */
export const Route = createFileRoute('/$tenant/projects/$projectId/approvals/$approvalId')({
  component: ApprovalDetailRoute,
});

function ApprovalDetailRoute() {
  const { tenant, projectId, approvalId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="agents"
      crumbs={[{ label: t('nav.items.agents') }, { label: approvalId, mono: true }]}
    >
      <ApprovalDetailPage tenantId={tenant} projectId={projectId} approvalId={approvalId} />
    </ConsoleShell>
  );
}
